import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import IPTEndpointAuditTable from "./IPTEndpointAuditTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const IPTEndpointAudit = () => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    siteAudits: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/IPTEndpointAudit/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          iPTAudits: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <IPTEndpointAuditTable data={dataObj.iPTAudits} />
        </div>
      )}
    </>
  );
};

export default IPTEndpointAudit;
